import { render, staticRenderFns } from "./outlay.vue?vue&type=template&id=35e0c472&lang=pug&"
import script from "./outlay.vue?vue&type=script&lang=js&"
export * from "./outlay.vue?vue&type=script&lang=js&"
import style0 from "./outlay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports